export default __webpack_public_path__ + "static/media/kaus-carousel-4-main.0b1a5a26.png";